export interface Project {
  name: string;
  description: string;
  playStoreUrl: string;
  appleAppStoreUrl: string;
  icon: string;
  longDescription?: string;
  tags?: string[];
  hidden?: boolean;
}
export const myProjects: Project[] = [
  {
    name: "ON AIR sign",
    description:
      "Control an ON AIR sign remotely. Perfect for filming shorts or practicing without interruption.",
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=au.com.rtcloud.onair",
    appleAppStoreUrl: "https://apps.apple.com/au/app/on-air-sign/id6758880437",
    icon: "assets/images/projects/onair.png",
    tags: [
      "Real time communication",
      "Implicit user control",
      "Real time backend API",
    ],
  },
  {
    hidden: true,
    name: "Reliable Food Distributors",
    description: "On-line ordering app for Reliable Foods",
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=au.com.esol.reliable",
    appleAppStoreUrl:
      "https://apps.apple.com/au/app/reliable-food-distributors/id1639056960",
    icon: "assets/images/projects/reliable.png",
    tags: [
      "3rd party API integration",
      "Custom API development",
      "Credit card payments",
    ],
  },
  {
    hidden: true,
    name: "Simotas Food Distributors",
    description: "esuite ordering app for Simotas Foods",
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=au.com.esol.simotas",
    appleAppStoreUrl:
      "https://apps.apple.com/au/app/simotas-food-distributors/id6448774783",
    icon: "assets/images/projects/simotas-inverted.png",
    tags: [
      "3rd party API integration",
      "Custom API development",
      "Credit card payments",
    ],
  },
  {
    hidden: true,
    name: "Taitung 365",
    description:
      "Order with Taitung Food Service. Access all products and stay up to date with latest specials.",
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=au.com.esol.tfs",
    appleAppStoreUrl: "https://apps.apple.com/au/app/taitung-365/id6462687318",
    icon: "assets/images/projects/taitung-white-letters.png",
    tags: [
      "3rd party API integration",
      "Custom API development",
      "Credit card payments",
    ],
  },
];
